import { useField } from "formik";
import { InputControl, InputControlProps } from "formik-chakra-ui";
import React from "react";

type Props = { maxLength: number } & InputControlProps;
export const InputControlWithMaxLength: React.FC<Props> = ({
  maxLength,
  name,
  inputProps,
  ...props
}) => {
  const [field] = useField<string>(name);
  const helperText = React.useMemo(() => {
    return `${maxLength - field.value.length}`;
  }, [field.value.length, maxLength]);
  return (
    <InputControl
      name={name}
      inputProps={{
        maxLength,
        ...inputProps,
      }}
      marginBottom={0}
      helperText={helperText}
      {...props}
    />
  );
};
